export default __webpack_public_path__ + "69d6ff9f0df951c258db101578891078.jpg";